import {
  ProductVariantSortingInput,
  ProductVariantSortField,
  OrderDirection,
  ProductOrderField,
} from '@/graphql';
import { SortOrder } from './secondContent.types';
import { useTranslations } from 'next-intl';

export const TabsData = () => {
  const t = useTranslations('Components.category-second-content.tabs-data');

  return [
    t('cheapest'),
    t('expensive'),
    t('newest'),
    t('popular'),
    t('reccomend'),
  ];
};

export function TabsData2(): { title: string; click: SortOrder }[] {
  const t = useTranslations('Components.category-second-content.tabs-data');
  return [
    {
      title: t('cheapest'),
      click: {
        field: ProductOrderField.MINIMAL_PRICE,
        direction: OrderDirection.ASC,
      },
    },
    {
      title: t('expensive'),
      click: {
        field: ProductOrderField.MINIMAL_PRICE,
        direction: OrderDirection.DESC,
      },
    },
    {
      title: t('newest'),
      click: {
        field: ProductOrderField.CREATED_AT,
        direction: OrderDirection.DESC,
      },
    },
    {
      title: t('popular'),
      click: {
        field: ProductOrderField.POPULARITY,
        direction: OrderDirection.DESC,
      },
    },
    {
      title: t('reccomend'),
      click: {
        field: ProductOrderField.RECOMMENDATION,
        direction: OrderDirection.DESC,
      },
    },
  ];
}

export function TabsData3(): { click: ProductVariantSortingInput }[] {
  return [
    {
      click: {
        field: ProductVariantSortField.MINIMAL_PRICE,
        direction: OrderDirection.ASC,
      },
    },
    {
      click: {
        field: ProductVariantSortField.MINIMAL_PRICE,
        direction: OrderDirection.DESC,
      },
    },
    {
      click: {
        field: ProductVariantSortField.CREATED_AT,
        direction: OrderDirection.DESC,
      },
    },
    {
      click: {
        field: ProductVariantSortField.POPULARITY,
        direction: OrderDirection.DESC,
      },
    },
    {
      click: {
        field: ProductVariantSortField.RECOMMENDATION,
        direction: OrderDirection.DESC,
      },
    },
  ];
}

export const RADIO_BUTTONS = () => {
  const t = useTranslations('Components.category-second-content');
  return [
    {
      id: 1,
      value: t('all'),
      label: t('any'),
    },
    {
      id: 2,
      value: 5,
      label: `5% ${t('and-more')}`,
    },
    {
      id: 3,
      value: 10,
      label: `10% ${t('and-more')}`,
    },
    {
      id: 4,
      value: 20,
      label: `20% ${t('and-more')}`,
    },
    {
      id: 5,
      value: 30,
      label: `30% ${t('and-more')}`,
    },
  ];
};
